class DrKieuTestimonialCarousel extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('[data-testimonial-track]');
    this.cards = Array.from(this.querySelectorAll('[data-testimonial-card]'));
    this.previousButton = this.querySelector('[data-testimonial-previous]');
    this.nextButton = this.querySelector('[data-testimonial-next]');
    this.dots = Array.from(this.querySelectorAll('[data-testimonial-dot]'));

    if (!this.track || this.cards.length === 0) return;

    this.abortController = new AbortController();
    const { signal } = this.abortController;

    this.previousButton?.addEventListener('click', () => this.move(-1), { signal });
    this.nextButton?.addEventListener('click', () => this.move(1), { signal });

    this.dots.forEach((dot, index) => {
      dot.addEventListener('click', () => this.scrollToIndex(index), { signal });
    });

    this.track.addEventListener('scroll', () => this.queueUpdate(), { passive: true, signal });
    this.resizeObserver = new ResizeObserver(() => this.update());
    this.resizeObserver.observe(this.track);
    this.update();
  }

  disconnectedCallback() {
    this.abortController?.abort();
    this.resizeObserver?.disconnect();
    cancelAnimationFrame(this.updateFrame);
  }

  move(direction) {
    const currentIndex = this.getCurrentIndex();
    const nextIndex = (currentIndex + direction + this.cards.length) % this.cards.length;
    this.scrollToIndex(nextIndex);
  }

  scrollToIndex(index) {
    const card = this.cards[index];
    if (!card) return;

    const maximumScroll = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
    const target = Math.min(card.offsetLeft, maximumScroll);
    this.track.scrollTo({ left: target, behavior: 'smooth' });

    this.dots.forEach((dot, dotIndex) => {
      if (dotIndex === index) dot.setAttribute('aria-current', 'true');
      else dot.removeAttribute('aria-current');
    });
  }

  getCurrentIndex() {
    const currentScroll = this.track.scrollLeft;
    let closestIndex = 0;
    let closestDistance = Number.POSITIVE_INFINITY;

    this.cards.forEach((card, index) => {
      const distance = Math.abs(card.offsetLeft - currentScroll);
      if (distance < closestDistance) {
        closestDistance = distance;
        closestIndex = index;
      }
    });

    return closestIndex;
  }

  queueUpdate() {
    cancelAnimationFrame(this.updateFrame);
    this.updateFrame = requestAnimationFrame(() => this.update());
  }

  update() {
    const activeIndex = this.getCurrentIndex();
    this.dots.forEach((dot, index) => {
      if (index === activeIndex) dot.setAttribute('aria-current', 'true');
      else dot.removeAttribute('aria-current');
    });
  }
}

if (!customElements.get('dr-kieu-testimonial-carousel')) {
  customElements.define('dr-kieu-testimonial-carousel', DrKieuTestimonialCarousel);
}
